import apiClient from './ApiClient';

export class WorkflowRepository {
	constructor(client) {
		this.client = client;
		this.basePath = '/api/workflows';
	}

	async list() {
		return this.client.get(this.basePath);
	}

	async getById(workflowId) {
		return this.client.get(`${this.basePath}/${workflowId}`);
	}

	async create(payload) {
		return this.client.post(this.basePath, payload);
	}

	async update(workflowId, payload) {
		return this.client.put(`${this.basePath}/${workflowId}`, payload);
	}

	async delete(workflowId) {
		return this.client.delete(`${this.basePath}/${workflowId}`);
	}
}

export default new WorkflowRepository(apiClient);
